var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKenya = function SvgKenya(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kenya_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3 10h21v1H-3v-1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3 11h21v4H-3v-4Z",
    fill: "#0A6A30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3 5h21v5H-3V5Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3 4h21v1H-3V4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.414 5.914c.072 0 .5-.67.5-1.5 0-.828-.428-1.5-.5-1.5-.07 0-.5.672-.5 1.5 0 .83.43 1.5.5 1.5Zm-2.94-.439c-.05.05-.83-.12-1.413-.707-.585-.586-.757-1.364-.706-1.414.05-.05.828.12 1.414.707.586.586.757 1.364.707 1.415l-.001-.001Zm1.88 4.533c.05-.047.83.113 1.415.66.585.55.757 1.277.707 1.324-.05.047-.83-.113-1.416-.66-.585-.55-.757-1.277-.706-1.324Zm-1.88 0c-.05-.047-.83.113-1.413.66-.585.55-.757 1.277-.706 1.324.05.047.828-.113 1.414-.66.586-.55.757-1.277.707-1.324h-.001Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 12c.357 0 2.5-2.015 2.5-4.5S7.857 3 7.5 3C7.143 3 5 5.015 5 7.5S7.143 12 7.5 12Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 9c.07 0 .5-.672.5-1.5S5.57 6 5.5 6 5 6.672 5 7.5 5.43 9 5.5 9Zm4 0c.07 0 .5-.672.5-1.5S9.57 6 9.5 6 9 6.672 9 7.5 9.43 9 9.5 9Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5C8 6.672 7.776 6 7.5 6S7 6.672 7 7.5 7.224 9 7.5 9s.5-.672.5-1.5Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kenya_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#fff"
  })))));
};
export default SvgKenya;